import React, { useEffect, useState, KeyboardEvent } from "react";
import { BroadcastMessage } from "../../lib/types";
import "./speakerNotesPage.scss";
import { Loading } from "../loading";

interface SpeakerNotesPageProps {
	match?: any;
	channelName?: string;
}

const toTimeString = (date: Date): string => {
	return `${date
		.getMinutes()
		.toString()
		.padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;
};

export const SpeakerNotesPage = (props: SpeakerNotesPageProps) => {
	const [notes, setNotes] = useState<string>();
	const [slideIndex, setSlideIndex] = useState<number>(0);
	const [maxIndex, setMaxIndex] = useState<number>(0);
	const [startTime, setStartTime] = useState<number>();
	const [currentDuration, setCurrentDuration] = useState<number>();
	const [timer, setTimer] = useState<NodeJS.Timeout>();
	const [
		broadcastChannel,
		setbroadcastChannel,
	] = useState<BroadcastChannel>();

	if (!broadcastChannel) {
		return <h1>Broadcast channel is not supported in this browser</h1>;
	}

	let channelName: string;
	if (props.channelName) {
		channelName = props.channelName;
	} else if (props.match.params.channel) {
		channelName = props.match.params.channel;
	} else {
		console.error("Channel name was not provided.");
	}

	const sendSlideNavMessage = (index: number) => {
		if (index < 0) {
			index = 0;
		}
		if (index > maxIndex) {
			index = maxIndex;
		}
		broadcastChannel.postMessage({
			currentIndex: index,
		} as BroadcastMessage);
	};

	const handleKeyPress = (e: KeyboardEvent) => {
		console.log(e);
		switch (e.key) {
			case "ArrowLeft":
				e.preventDefault();
				sendSlideNavMessage(slideIndex - 1);
				break;
			case "ArrowRight":
				e.preventDefault();
				sendSlideNavMessage(slideIndex + 1);
				break;
			default:
				break;
		}
	};

	useEffect(() => {
		// On first render
		let bc = new BroadcastChannel(channelName);

		setbroadcastChannel(bc);

		bc.addEventListener("message", (message) => {
			const data = message.data as BroadcastMessage;
			setNotes(data.notes);
			setSlideIndex(data.currentIndex);
			setMaxIndex(data.maxIndex ?? 0);
		});

		document.title = `slide notes | ${channelName}`;
	}, []);

	useEffect(() => {
		if (timer) {
			window.clearInterval(timer);
		}

		setTimer(
			setInterval(() => {
				setCurrentDuration(Date.now() - (startTime ?? 0));
			}, 1000)
		);
	}, [startTime]);

	return (
		<div
			className="speaker-notes"
			onKeyDown={(e) => {
				handleKeyPress(e);
			}}
			tabIndex={0}
		>
			{maxIndex !== 0 ? (
				<>
					<div className="speaker-notes__content">
						<div className="speaker-notes__stats">
							<div>{`${slideIndex}/${maxIndex}`}</div>

							<div>
								{currentDuration ? (
									toTimeString(new Date(currentDuration))
								) : (
									<button
										className="speaker-notes__button speaker-notes__button--timer"
										title="start timer"
										role="button"
										tabIndex={0}
										onClick={() => {
											setStartTime(Date.now());
										}}
									>
										<i className="material-icons">
											play_arrow
										</i>
										00:00
									</button>
								)}
							</div>
						</div>
						<pre>
							<div className="speaker-notes__notes">{notes}</div>
						</pre>
					</div>
					<div className="speaker-notes__controls">
						<button
							title="previous slide"
							disabled={slideIndex === 0}
							className={`speaker-notes__button speaker-notes__button--nav ${
								slideIndex === 0
									? "speaker-notes__button--disabled"
									: ""
							}`}
							onClick={() => {
								sendSlideNavMessage(slideIndex - 1);
							}}
						>
							<i className="material-icons">chevron_left</i>
						</button>
						<button
							title="next slide"
							className={`speaker-notes__button speaker-notes__button--nav  ${
								slideIndex === maxIndex
									? "speaker-notes__button--disabled"
									: ""
							}`}
							disabled={slideIndex === maxIndex}
							onClick={() => {
								sendSlideNavMessage(slideIndex + 1);
							}}
						>
							<i className={"material-icons"}>chevron_right</i>
						</button>
					</div>
				</>
			) : (
				<Loading />
			)}
		</div>
	);
};
